export default "__VITE_ASSET__DkmSk5Dx__"